import React, { FunctionComponent } from 'react'
import { VerificationFlowContext, VerificationMethod } from '@afterpaytouch/registration'
import { Grid, Text } from '@afterpaytouch/core'
import { MaskedElement } from '@afterpaytouch/integrations/MaskedElement'
import { useCheckoutSizes } from '../../utils/responsive'
import { Trans } from '../../utils/convergence'

export const getTranslationKey = (isRevealMobile: boolean, context: VerificationFlowContext, method?: VerificationMethod, destination?: string): string => {
  if (method === undefined) {
    return ''
  }
  if (context === VerificationFlowContext.Efa) {
    return `verify:sms:descriptionEfa`
  }
  const variant = isRevealMobile ? 'descriptionRevealMobile' : destination === '' ? 'descriptionNoDestination' : 'description'
  return `verify:${method?.toLowerCase()}:${variant}`
}

interface DescriptionProps {
  method?: VerificationMethod
  isRevealMobile: boolean
  mobile: string
  email?: string
  wasAutoSent: boolean
  context: VerificationFlowContext
}

export const Description: FunctionComponent<DescriptionProps> = ({ method, isRevealMobile, mobile, email = '', wasAutoSent, context }) => {
  const translationKey = getTranslationKey(isRevealMobile, context, method, method === VerificationMethod.EMAIL ? email : mobile)
  const { textSize } = useCheckoutSizes()
  if (method === undefined) {
    return null
  }
  return (
    <Grid>
      <MaskedElement actionName='Verification Code Sent Description'>
        <Text size={textSize} id='verify-code'>
          <Trans i18nKey={translationKey} values={{ mobile, email, context: wasAutoSent ? 'auto' : '' }} components={{ br: <br /> }} />
        </Text>
      </MaskedElement>
    </Grid>
  )
}
